<template>
  <main class="min-h-[60vh] flex items-center justify-center px-4 py-16">
    <section class="w-full max-w-[640px] rounded-[2.4rem] border border-black/10 bg-white p-8 shadow-sm text-center space-y-4">
      <p class="m-0 text-[1.8rem] font-semibold text-black">
        {{ $t('Sorry! The payment has not been completed') }}
      </p>
      <p class="m-0 text-[1.4rem] text-[color:var(--gray)]">
        {{ $t('Please try again later') }}
      </p>
      <router-link
        to="/"
        class="inline-flex items-center justify-center rounded-xl bg-black px-4 py-2 text-[1.3rem] font-semibold text-white transition hover:bg-black/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
      >
        {{ $t('Continue Shopping') }}
      </router-link>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckoutKoView',
});
</script>
